import { useMutation, useQueryClient } from 'react-query';
import { enqueueSnackbar } from 'notistack';

import { updateSignature } from 'api/profile/updateSignature';

const useUpdateSignature = () => {
  const queryClient = useQueryClient();

  const { mutate: updateSignatureMutation, isLoading: isSignatureUpdating } = useMutation(updateSignature, {
    onSuccess: () => {
      enqueueSnackbar('Signature updated successfully', { variant: 'success' });
      queryClient.invalidateQueries(['profile']);
    },
    onError: (error: any) => {
      enqueueSnackbar(error.message || 'Error updating signature', { variant: 'error' });
    },
  });

  return { updateSignatureMutation, isSignatureUpdating };
};

export default useUpdateSignature;
